import blank from './blank';
import cellphone from './cellphone';
import cellphoneNumber from './cellphone-number';
import confirmation from './confirmation';
import constant from './constant';
import chassis from './chassis';
import cnpj from './cnpj';
import cpf from './cpf';
import cpfOrCnpj from './cpf-or-cnpj';
import custom from './custom';
import date from './date';
import digit from './digit';
import domain from './domain';
import email from './email';
import exists from './exists';
import file from './file';
import fn from './fn';
import greaterThan from './greater-than';
import greaterThanOrEqualTo from './greater-than-or-equal-to';
import handle from './handle';
import inclusion from './inclusion';
import installments from './installments';
import invalid from './invalid';
import lessThan from './less-than';
import lessThanOrEqualTo from './less-than-or-equal-to';
import notANumber from './not-a-number';
import phone from './phone';
import phoneCode from './phone-code';
import phoneNumber from './phone-number';
import plate from './plate';
import renavam from './renavam';
import ruled from './ruled';
import taken from './taken';
import tooLong from './too-long';
import tooShort from './too-short';
import unique from './unique';
import zip from './zip';

const validators = {
  blank,
  cellphone,
  cellphoneNumber,
  confirmation,
  constant,
  chassis,
  custom,
  cnpj,
  cpf,
  cpfOrCnpj,
  date,
  digit,
  domain,
  email,
  exists,
  file,
  fn,
  greaterThan,
  greaterThanOrEqualTo,
  handle,
  inclusion,
  invalid,
  installments,
  lessThan,
  lessThanOrEqualTo,
  notANumber,
  phone,
  phoneCode,
  phoneNumber,
  plate,
  renavam,
  ruled,
  taken,
  tooLong,
  tooShort,
  unique,
  zip,
};

function cammelCase(name) {
  return name.replace(/[A-Z]/g, (i) => `_${i}`).toLowerCase();
}

// credere's api validators normalizer
Object.keys(validators).forEach((validator) => {
  const cammel = cammelCase(validator);

  if (validators[cammel]) {
    return;
  }

  validators[cammel] = validators[validator];
});

export default validators;
